import React from 'react';
import { Grid } from '@material-ui/core';
import { HistoryEvents } from 'ApplicationEntry/models/PolicyHistoryItems';
import './WorkFlow.sass';

type PolicyHistoryPanelProps = {
    policyHistoryItems: HistoryEvents[];
};

const PolicyHistoryPanel = (props: PolicyHistoryPanelProps) => {

    const { policyHistoryItems } = props;

    return (
        <>
            {policyHistoryItems.map((policyHistoryItem: HistoryEvents, index: number) => {
                return (
                    <div className="summary-line-info__expansion-panel-details__policy-history" key={index}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} sm={6} md={2}>
                                <span className="title">Begin Date: </span>
                                <span className="value">{policyHistoryItem.beginDate}</span>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <span className="title">Begin Time: </span>
                                <span className="value">{policyHistoryItem.beginTime}</span>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <span className="title">User Name: </span>
                                <span className="value">{policyHistoryItem.userNameContent}</span>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <span className="title">Status: </span>
                                <span className="value">{policyHistoryItem.statusNameContent}</span>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <span className="title">Queue: </span>
                                <span className="value">{policyHistoryItem.queueNameContent}</span>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <span className="title">Type: </span>
                                <span className="value">{policyHistoryItem.typeNameContent}</span>
                            </Grid>
                            <Grid item xs={12} sm={6} md={12} className="separator">
                                <span className="title">Comments: </span>
                                <span className="comment-value">{policyHistoryItem.text}</span>
                            </Grid>
                        </Grid>
                    </div>
                );
            })}
        </>
    )
}

export default PolicyHistoryPanel;
